import { render, staticRenderFns } from "./CfsiPictures.vue?vue&type=template&id=2f3710f2&scoped=true&"
import script from "./CfsiPictures.vue?vue&type=script&lang=js&"
export * from "./CfsiPictures.vue?vue&type=script&lang=js&"
import style0 from "./CfsiPictures.vue?vue&type=style&index=0&id=2f3710f2&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f3710f2",
  null
  
)

export default component.exports